"use client";

import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Box,
} from "@mui/material";
import { TiptapTextEditor } from "./TiptapTextEditor";
import { Motto } from "utils/types/Info.types";


interface MottoDialogProps {
  open: boolean;
  isSaving: boolean;
  onClose: () => void;
  onSave: (motto: Omit<Motto, 'id'> & { id?: string }) => void;
  initialData?: Motto | null;
}


export const MottoDialog: React.FC<MottoDialogProps> = ({
  open,
  isSaving,
  onClose,
  onSave,
  initialData,
}) => {
  const [mottoText, setMottoText] = useState("");
  const [mottoId, setMottoId] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (open) {
      setMottoText(initialData?.motto || "");
      setMottoId(initialData?.id);
    } else {
      // Reset when closed
      setMottoText("");
      setMottoId(undefined);
    }
  }, [initialData, open]);

  const handleSave = () => {
    onSave({
      id: mottoId,
      motto: mottoText,
    });
  };

  // We need to pass a 'data' prop to TiptapTextEditor
  const editorData = {
    text: mottoText,
    // Add default styles if your TiptapTextEditor expects them
    style: { 
      color: "black",
      fontSize: "16px",
      width: "100%",
      fontFamily: "Arial",
      textAlign: "left",
      lineHeight: "1.5",
      letterSpacing: "normal",
      fontWeight: "normal"
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        {mottoId ? "Modifier le Motto" : "Ajouter un Motto"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TiptapTextEditor
            data={editorData}
            onChange={(data) => setMottoText(data.text)}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={isSaving}>Annuler</Button>
        <Button 
          onClick={handleSave} 
          color="primary" 
          variant="contained" 
          disabled={isSaving}
          startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isSaving ? "Sauvegarde..." : "Sauvegarder"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};